// @flow
import React, { useRef } from 'react';
import { FieldArray, useFormikContext } from 'formik';
import { isAnythingEditedBesidesGivenFormBasedOnGivenConfig } from '@streaming-projects/utils';
import { SP_USER_COMMIT_PAGE_CONFIG } from '@streaming-projects/user-commit-details/config';
import { FORM_NAMES } from '@streaming-projects/enums';
import { getConfiguredMetricRowsFromFormikValues } from '@streaming-projects/user-commit-details/committed-capacity/utils';
import { PaddedAndRaisedSegment } from '@presentational/PaddedAndRaisedSegment';
import { CommittedCapacityDescriberContainer } from '@streaming-projects/user-commit-details/committed-capacity/CommittedCapacityDescriberContainer';
import { AddNewMetricButton } from '@streaming-projects/user-commit-details/committed-capacity/AddNewMetricButton';
import { Spacer } from '@presentational/spacing/Spacer';
import { Divider, Grid } from 'semantic-ui-react';
import { COMMITTED_CAPACITY } from '@streaming-projects/user-commit-details/committed-capacity/enums';
import { SPCommittedCapacityMetricNameDropdownContainer } from '@streaming-projects/user-commit-details/committed-capacity/SPCommittedCapacityMetricNameDropdownContainer';
import { SPCommittedCapacityDimensionsGrid } from '@streaming-projects/user-commit-details/committed-capacity/SPCommittedCapacityDimensionsGrid';
import { SPCommittedCapacityAddMetricRowContainer } from '@streaming-projects/user-commit-details/committed-capacity/SPCommittedCapacityAddMetricRowContainer';

const AddMetricNameDropdownRow = ({ index, metricDimensionRefs, row }) => (
  <Grid.Row>
    <Grid.Column width={3}>
      <SPCommittedCapacityMetricNameDropdownContainer
        dimensionsArrayHelpers={
          metricDimensionRefs.current.dimensionArrayHelpersMap[row.metricName]
        }
        index={index}
        row={row}
      />
    </Grid.Column>
  </Grid.Row>
);

const AddNewMetricRowRelatedRow = ({ metricDimensionRefs, row }) => (
  <Grid.Row>
    <Grid.Column width={3}>
      <SPCommittedCapacityAddMetricRowContainer
        dimensionsArrayHelpers={
          metricDimensionRefs.current.dimensionArrayHelpersMap[row.metricName]
        }
        metricRow={row}
      />
    </Grid.Column>
  </Grid.Row>
);

export const SPUserCommitCommittedCapacityConfigurationContainer = () => {
  const { values: formikValues, initialValues } = useFormikContext();
  const shouldFormBeDisabled = isAnythingEditedBesidesGivenFormBasedOnGivenConfig(
    initialValues,
    formikValues,
    SP_USER_COMMIT_PAGE_CONFIG,
    FORM_NAMES.COMMITTED_CAPACITY.COMMITTED_CAPACITY_FORM
  );
  const metricDimensionRefs = useRef({
    metricLevelArrayHelpers: null,
    dimensionArrayHelpersMap: {},
  });
  const configuredMetricRows = getConfiguredMetricRowsFromFormikValues(formikValues);
  return (
    <PaddedAndRaisedSegment disabled={shouldFormBeDisabled}>
      <CommittedCapacityDescriberContainer />
      <AddNewMetricButton
        metricLevelArrayHelpers={metricDimensionRefs.current.metricLevelArrayHelpers}
      />
      <Spacer y={40} />
      <Grid>
        <FieldArray
          name={COMMITTED_CAPACITY.METRICS_LEVEL_CONFIGURATION_ARRAY}
          render={(arrayHelpers) => {
            metricDimensionRefs.current.metricLevelArrayHelpers = arrayHelpers;
            return (
              <>
                {configuredMetricRows.map((row, index) => {
                  return (
                    <React.Fragment key={`${index}${row.id}`}>
                      <AddMetricNameDropdownRow
                        index={index}
                        metricDimensionRefs={metricDimensionRefs}
                        row={row}
                      />
                      <SPCommittedCapacityDimensionsGrid
                        metricArrayHelpers={arrayHelpers}
                        metricDimensionRefs={metricDimensionRefs}
                        metricIndex={index}
                        metricRow={row}
                      />
                      <AddNewMetricRowRelatedRow
                        metricDimensionRefs={metricDimensionRefs}
                        row={row}
                      />
                      <Divider />
                    </React.Fragment>
                  );
                })}
              </>
            );
          }}
        />
      </Grid>
    </PaddedAndRaisedSegment>
  );
};
